// extracted by mini-css-extract-plugin
export default {"full":"Projects_full__aK-RZ","projects":"Projects_projects__0HGLx"};